<!-- eslint-disable max-len -->
<form [formGroup]="createSspService.newSSPForm">
  <div class="platform-form endpoint-edit-form" [style.height]="formHeight">
    <div class="platform-form__top" *nzModalTitle>
      <div class="switch">
        <nz-switch
          switchLabel="activateSSPEndpoint"
          [(ngModel)]="createSspService.isActive"
          name="active"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onChangeActive($event)"
        ></nz-switch>
      </div>
      <div class="type">
        <span *ngIf="createSspService.connectionType === 'rtb'">RTB</span>
        <span *ngIf="createSspService.connectionType === 'vast'">VAST</span>
        <span *ngIf="createSspService.connectionType === 'js'">JS</span>
        <span *ngIf="createSspService.connectionType === 'prebid'">Prebid</span>
        <span *ngIf="createSspService.connectionType === 'prebidJs'"
          >Prebid.js</span
        >
      </div>
      <div class="wrap">
        Supply Endpoint
        <span>Company Name</span>
      </div>
    </div>
    <div class="platform-form__middle">
      <div class="part">
        <div class="form-title">General</div>
        <div class="form-group">
          <label for="endpointSSPName">Name *</label>
          <input
            nz-input
            type="text"
            id="endpointSSPName"
            required
            name="name"
            (input)="onValidateSpaceForName()"
            formControlName="name"
            class="form-control"
          />
        </div>
        <div class="form-group form-radio">
          <label class="label-title">
            Connection Type
            <app-tooltip
              [tooltipTitle]="
                'Choose whether the endpoint works according to RTB specifications or VAST.'
              "
            ></app-tooltip>
          </label>
          <div class="form-group">
            <div class="margin-group">
              <nz-radio-group
                formControlName="connectionType"
                name="connectionType"
                id="connectionType"
                nzButtonStyle="solid"
                [attr.qa]="createSspService.formValue.connectionType"
              >
                <label nz-radio-button nzValue="rtb" style="width: 20%" qa="rtb"
                  >RTB</label
                >
                <label
                  nz-radio-button
                  nzValue="vast"
                  style="width: 20%"
                  qa="vast"
                  >VAST</label
                >
                <label
                  nz-radio-button
                  nzValue="prebid"
                  style="width: 20%"
                  [nzDisabled]="createSspService.isPartnerPlanBasic"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    createSspService.restrictionTooltipMessage(
                      'Prebid connection type'
                    )
                  "
                  nzTooltipPlacement="top"
                  qa="prebid"
                  >Prebid</label
                >
                <label nz-radio-button nzValue="js" style="width: 20%" qa="js"
                  >JS</label
                >
                <label
                  nz-radio-button
                  nzValue="prebidJs"
                  style="width: 20%"
                  [nzDisabled]="createSspService.isPartnerPlanBasic"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    createSspService.restrictionTooltipMessage(
                      'Prebid.js connection type'
                    )
                  "
                  nzTooltipPlacement="top"
                  qa="prebidJs"
                  >Prebid.js</label
                >
              </nz-radio-group>
            </div>
          </div>
        </div>

        <div
          class="form-group form-group_chb mb-27"
          *ngIf="
            createSspService.isRtbConnection() &&
            createSspService.partnerSettings.useSsl
          "
        >
          <label for="isSecure"></label>
          <label nz-checkbox formControlName="isSecure" name="isSecure"
            >Secure endpoint</label
          >
        </div>
        <div class="form-group" *ngIf="createSspService.isRtbConnection()">
          <label>RTB Connection</label>
          <div class="btn-group btn-group--rtb">
            <label
              [class.active]="
                createSspService.formValue.rtbConnectionMode === 0
              "
            >
              RTB to ALL
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createSspService.formValue.rtbConnectionMode === 0"
                [value]="0"
              />
            </label>
            <label
              [class.active]="
                createSspService.formValue.rtbConnectionMode === 2
              "
            >
              RTB to RTB
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createSspService.formValue.rtbConnectionMode === 2"
                [value]="2"
              />
            </label>
            <label
              [class.active]="
                createSspService.formValue.rtbConnectionMode === 1
              "
            >
              RTB to VAST
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createSspService.formValue.rtbConnectionMode === 1"
                [value]="1"
              />
            </label>
            <label
              [class.active]="
                createSspService.formValue.rtbConnectionMode === 3
              "
            >
              RTB to JS
              <input
                type="radio"
                formControlName="rtbConnectionMode"
                [checked]="createSspService.formValue.rtbConnectionMode === 3"
                [value]="3"
              />
            </label>
          </div>
        </div>
        <div class="form-group" *ngIf="createSspService.isVastConnection()">
          <label>VAST Connection</label>
          <div class="btn-group btn-group--vast">
            <label
              [class.active]="
                createSspService.formValue.vastConnectionMode === 0
              "
            >
              VAST to ALL
              <input
                type="radio"
                formControlName="vastConnectionMode"
                [checked]="createSspService.formValue.vastConnectionMode === 0"
                [value]="0"
              />
            </label>
            <label
              [class.active]="
                createSspService.formValue.vastConnectionMode === 2
              "
            >
              VAST to RTB
              <input
                type="radio"
                formControlName="vastConnectionMode"
                [checked]="createSspService.formValue.vastConnectionMode === 2"
                [value]="2"
              />
            </label>
            <label
              [class.active]="
                createSspService.formValue.vastConnectionMode === 1
              "
            >
              VAST to VAST
              <input
                type="radio"
                formControlName="vastConnectionMode"
                [checked]="createSspService.formValue.vastConnectionMode === 1"
                [value]="1"
              />
            </label>
          </div>
        </div>
        <div
          *ngIf="
            createSspService.isPreBidConnection() ||
            createSspService.isRtbConnection() ||
            createSspService.isPrebidJsConnection()
          "
        >
          <div class="form-title form-title--checkbox">Ad Format</div>
          <div class="form-group form-group_chb form-group_check">
            <div class="custom-checkbox">
              <div class="checkbox">
                <label
                  checkboxLabel="bannerAdFormatSSP"
                  nz-checkbox
                  [ngClass]="
                    createSspService.isRequiredAdFormat
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="isBanner"
                  (ngModelChange)="onChangeChecked($event, 'isBanner')"
                  name="isBanner"
                  >Banner</label
                >
              </div>
              <div class="checkbox">
                <label
                  checkboxLabel="nativeAdFormatSSP"
                  (ngModelChange)="onChangeChecked($event, 'isNative')"
                  nz-checkbox
                  [ngClass]="
                    createSspService.isRequiredAdFormat
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="isNative"
                  name="isNative"
                  >Native</label
                >
              </div>
              <div class="checkbox">
                <label
                  nz-checkbox
                  checkboxLabel="videoAdFormatSSP"
                  (ngModelChange)="onChangeChecked($event, 'isVideo')"
                  [ngClass]="
                    createSspService.isRequiredAdFormat
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="isVideo"
                  name="isVideo"
                  >Video</label
                >
              </div>
              <div class="checkbox">
                <label
                  checkboxLabel="rewardedVideoAdFormatSSP"
                  nz-checkbox
                  (ngModelChange)="onChangeChecked($event, 'rewarded')"
                  [ngClass]="
                    createSspService.isRequiredAdFormat
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="rewarded"
                  [nzDisabled]="
                    createSspService.formValue['isAudio'] ||
                    createSspService.isPrebidJsConnection()
                  "
                  name="rewarded"
                  >Rewarded video</label
                >
              </div>
              <div class="checkbox">
                <label
                  checkboxLabel="audioAdFormatSSP"
                  nz-checkbox
                  (ngModelChange)="onChangeChecked($event, 'isAudio')"
                  [ngClass]="
                    createSspService.isRequiredAdFormat
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="isAudio"
                  name="isAudio"
                  *ngIf="!createSspService.isPreBidConnection()"
                  [nzDisabled]="
                    createSspService.formValue['ctv'] ||
                    createSspService.formValue['rewarded'] ||
                    createSspService.isPrebidJsConnection()
                  "
                  >Audio</label
                >
              </div>
            </div>
          </div>
        </div>
        <hr
          *ngIf="
            createSspService.isPreBidConnection() ||
            createSspService.isRtbConnection() ||
            createSspService.isPrebidJsConnection()
          "
        />
        <div
          class="form-title form-title--traffic"
          *ngIf="
            createSspService.isRtbConnection() ||
            createSspService.isPreBidConnection() ||
            createSspService.isPrebidJsConnection()
          "
        >
          Traffic type
        </div>
        <div
          class="form-group form-group_chb form-group_check rtb-ad-types"
          *ngIf="
            createSspService.isRtbConnection() ||
            createSspService.isPreBidConnection() ||
            createSspService.isPrebidJsConnection()
          "
        >
          <div class="custom-checkbox">
            <div class="checkbox">
              <label
                checkboxLabel="mobileWebTrafficTypeSSP"
                nz-checkbox
                [ngClass]="
                  createSspService.isRequiredTrafficType
                    ? 'required-label'
                    : 'fake-label'
                "
                formControlName="mobile_web"
                name="mobile_web"
                >Mobile web</label
              >
            </div>
            <div class="checkbox">
              <label
                checkboxLabel="mobileAppTrafficTypeSSP"
                nz-checkbox
                [ngClass]="
                  createSspService.isRequiredTrafficType
                    ? 'required-label'
                    : 'fake-label'
                "
                formControlName="mobile_app"
                [nzDisabled]="createSspService.isPrebidJsConnection()"
                name="mobile_app"
                >Mobile app</label
              >
            </div>
            <div class="checkbox">
              <label
                checkboxLabel="desktopTrafficTypeSSP"
                nz-checkbox
                [ngClass]="
                  createSspService.isRequiredTrafficType
                    ? 'required-label'
                    : 'fake-label'
                "
                formControlName="desktop"
                name="desktop"
                >Desktop</label
              >
            </div>
            <div class="checkbox">
              <label
                checkboxLabel="ctvTrafficTypeSSP"
                nz-checkbox
                [ngClass]="
                  createSspService.isRequiredTrafficType
                    ? 'required-label'
                    : 'fake-label'
                "
                formControlName="ctv"
                name="ctv"
                [nzDisabled]="
                  createSspService.formValue['isAudio'] ||
                  createSspService.isPrebidJsConnection()
                "
                >CTV</label
              >
            </div>
          </div>
        </div>
        <hr
          *ngIf="
            createSspService.isPreBidConnection() ||
            createSspService.isRtbConnection() ||
            createSspService.isPrebidJsConnection()
          "
        />
        <div *ngIf="createSspService.isVastConnection()">
          <div class="form-title form-title--checkbox">Ad Format</div>
          <div class="form-group form-group_chb form-group_check">
            <div class="hub-row">
              <div class="hub-part">
                <div class="checkbox">
                  <label
                    checkboxLabel="videoAdFormatSSPVastJS"
                    nz-checkbox
                    [ngClass]="
                      createSspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="isVideo"
                    [nzDisabled]="
                      createSspService.formValue['isAudio'] ||
                      createSspService.formValue['rewarded']
                    "
                    name="isVideo"
                    >Video</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="rewardedVideoFormatSSPVastJS"
                    nz-checkbox
                    [ngClass]="
                      createSspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="rewarded"
                    name="rewarded"
                    [nzDisabled]="
                      createSspService.formValue['isVideo'] ||
                      createSspService.formValue['isAudio']
                    "
                    >Rewarded video</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="audioAdFormatSSPVastJS"
                    nz-checkbox
                    [ngClass]="
                      createSspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="isAudio"
                    name="isAudio"
                    [nzDisabled]="
                      createSspService.formValue['isVideo'] ||
                      createSspService.formValue['rewarded']
                    "
                    >Audio</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr *ngIf="createSspService.isVastConnection()" />
        <div
          class="form-group form-radio"
          *ngIf="
            createSspService.isVastConnection() ||
            createSspService.isJSConnection()
          "
        >
          <label class="form-title form-title--traffic"
            >Traffic Type
            <app-tooltip
              [tooltipTitle]="
                'Choose whether the endpoint works according to RTB specifications or VAST.'
              "
            ></app-tooltip>
          </label>
          <div class="ad-types">
            <div class="radio-50">
              <label
                class="custom-radio"
                checkboxLabel="mobileWebTrafficTypeSSPVastJS"
              >
                Mobile web
                <input
                  (change)="onChangeAdType()"
                  formControlName="adtype"
                  type="radio"
                  name="adtype"
                  value="mobile_web"
                  qa="mobileWeb"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="radio-50">
              <label
                class="custom-radio"
                checkboxLabel="desktopTrafficTypeSSPVastJS"
              >
                Desktop
                <input
                  (change)="onChangeAdType()"
                  formControlName="adtype"
                  type="radio"
                  name="adtype"
                  value="desktop"
                  qa="desktop"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <div class="ad-types">
            <div class="radio-50">
              <label
                class="custom-radio"
                checkboxLabel="mobileAppTrafficTypeSSPVastJS"
              >
                Mobile app
                <input
                  (change)="onChangeAdType()"
                  formControlName="adtype"
                  type="radio"
                  name="adtype"
                  value="mobile_app"
                  qa="mobileApp"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="radio-50" *ngIf="!createSspService.isJSConnection()">
              <label
                class="custom-radio"
                checkboxLabel="ctvTrafficTypeSSPVastJS"
              >
                CTV
                <input
                  (change)="onChangeAdType()"
                  formControlName="adtype"
                  type="radio"
                  name="adtype"
                  value="ctv"
                  qa="ctv"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <hr
          *ngIf="
            createSspService.isVastConnection() ||
            createSspService.isJSConnection()
          "
        />
        <div
          class="form-group"
          *ngIf="createSspService.isVastConnection()"
          formGroupName="vast"
        >
          <label class="label-title" for="vastBidfloorSSP"
            >Fixed Bidfloor *
            <app-tooltip
              tooltipTitle="The value entered here is used as the fixed payout to SSP partners. This value represents the cost per thousand impressions (CPM). The minimal Fixed Bidfloor value is 0.01."
            ></app-tooltip>
          </label>
          <div class="ssp-limit">
            <input
              nz-input
              class="form-control"
              id="vastBidfloorSSP"
              required
              name="bidfloor"
              formControlName="bidfloor"
              qa="bidfloor"
              min="0.01"
            />
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="createSspService.isVastConnection()"
          formGroupName="vast"
        >
          <label>Sizes</label>
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Selected Size"
            formControlName="selectedSizes"
            name="sizes"
          >
            <nz-option
              *ngFor="let size of createSspService.sizesList"
              [nzValue]="size.id"
              [nzLabel]="size.name"
            ></nz-option>
          </nz-select>
        </div>
        <div
          class="form-group"
          *ngIf="
            createSspService.isVastConnection() &&
            createSspService.isShowVastSizesControls
          "
          formGroupName="vast"
        >
          <div class="row b-row dsp-api-link-wrap">
            <div class="col-6">
              <label>Width *</label>
              <input
                type="number"
                nz-input
                name="w"
                id="customWidthVastSSP"
                formControlName="w"
                class="form-control"
              />
            </div>
            <div class="col-6">
              <label>Height *</label>
              <input
                type="number"
                nz-input
                name="h"
                id="customHeightVastSSP"
                formControlName="h"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="label-title"
            >Company *
            <app-tooltip
              [tooltipTitle]="'A company to which endpoint belongs'"
            ></app-tooltip>
          </label>
          <nz-select
            [ngClass]="
              createSspService.isRequiredCompany
                ? 'required-company'
                : 'company'
            "
            nzShowSearch
            nzPlaceHolder="Select or Create Company"
            formControlName="companyId"
            (ngModelChange)="onCompanyChange($event)"
            name="companyId"
          >
            <nz-option
              *ngFor="let company of createSspService.companies"
              [nzValue]="company.id"
              [nzLabel]="company.name"
            ></nz-option>
          </nz-select>
        </div>
        <div class="form-group">
          <label class="label-title"
            >Region *
            <app-tooltip
              [tooltipTitle]="'Region in which server capacities are located'"
            ></app-tooltip>
          </label>
          <nz-select
            [ngClass]="
              createSspService.isRequiredRegion ? 'required-region' : 'region'
            "
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Region"
            formControlName="region"
            name="region"
          >
            <nz-option
              *ngFor="let region of createSspService.regions"
              [nzValue]="region.id"
              [nzLabel]="region.name"
            ></nz-option>
          </nz-select>
        </div>
        <div
          class="form-group"
          *ngIf="
            createSspService.isRtbConnection() ||
            createSspService.isPreBidConnection() ||
            createSspService.isPrebidJsConnection() ||
            createSspService.isJSConnection()
          "
        >
          <label class="label-title" for="defaultTmaxSSP"
            >Default tmax
            <app-tooltip
              [tooltipTitle]="
                'This value applied when tmax field in a request is empty'
              "
            ></app-tooltip>
          </label>
          <input
            class="form-control"
            nz-input
            type="number"
            id="defaultTmaxSSP"
            name="defaultTmax"
            formControlName="defaultTmax"
          />
        </div>

        <div class="form-group" *ngIf="createSspService.isVastConnection()">
          <label class="label-title" for="defaultTmaxVastSSP"
            >Default tmax
            <app-tooltip
              [tooltipTitle]="
                'This value will override any other value in tmax field of oRTB request sent to RTB DSP endpoint, so this is what RTB DSP will see in the request from this SSP endpoint'
              "
            ></app-tooltip>
          </label>
          <input
            nz-input
            type="number"
            class="form-control"
            id="defaultTmaxVastSSP"
            name="defaultTmax"
            formControlName="defaultTmax"
          />
        </div>

        <div
          class="form-group"
          *ngIf="
            createSspService.isRtbConnection() ||
            createSspService.isPreBidConnection() ||
            createSspService.isPrebidJsConnection()
          "
        >
          <label class="label-title" for="defaultBidfloorSSP"
            >Default bidfloor
            <app-tooltip
              [tooltipTitle]="
                'This value applied when bidfloor field in a request is empty'
              "
            ></app-tooltip>
          </label>
          <input
            nz-input
            type="number"
            class="form-control"
            id="defaultBidfloorSSP"
            name="defaultBidfloor"
            formControlName="defaultBidfloor"
            qa="bidfloor"
          />
        </div>

        <div class="form-group">
          <label>Margin Type</label>
          <div class="margin-group">
            <nz-radio-group
              formControlName="margin_type"
              name="margin_type"
              nzButtonStyle="solid"
              (ngModelChange)="onChangeMarginType($event)"
            >
              <label nz-radio-button nzValue="fixed">Fixed</label>
              <label
                nz-radio-button
                nzValue="adaptive"
                [nzDisabled]="createSspService.isPartnerPlanBasic"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipMessage(
                    'Adaptive margin type'
                  )
                "
                nzTooltipPlacement="top"
                >Adaptive</label
              >
              <label
                nz-radio-button
                nzValue="range"
                [nzDisabled]="createSspService.isPartnerPlanBasic"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipMessage(
                    'Range margin type'
                  )
                "
                nzTooltipPlacement="top"
                >Range</label
              >
            </nz-radio-group>
          </div>
          <div
            class="margin"
            *ngIf="createSspService.formValue['margin_type'] === 'fixed'"
          >
            <div class="form-group">
              <label class="label-title" for="marginSSP"
                >Margin *
                <app-tooltip
                  [tooltipTitle]="
                    'Percent that the platform charges from the endpoint revenue'
                  "
                ></app-tooltip>
              </label>
              <input
                class="form-control"
                nz-input
                type="number"
                id="marginSSP"
                name="margin"
                min="0"
                max="100"
                formControlName="margin"
                placeholder="15 %"
                required
              />
            </div>
          </div>
          <div
            class="margin-section"
            *ngIf="createSspService.formValue['margin_type'] === 'range'"
          >
            <div class="margin-section__left">
              <div class="form-group">
                <label for="minMarginSSP">Min Margin *</label>
                <input
                  class="form-control"
                  nz-input
                  type="number"
                  id="minMarginSSP"
                  name="min_margin"
                  min="1"
                  max="100"
                  formControlName="min_margin"
                  placeholder="1 %"
                  required
                />
              </div>
            </div>
            <div class="margin-section__right">
              <div class="form-group">
                <label for="maxMarginSSP">Max Margin *</label>
                <input
                  class="form-control"
                  nz-input
                  type="number"
                  id="maxMarginSSP"
                  name="max_margin"
                  min="1"
                  max="100"
                  formControlName="max_margin"
                  placeholder="100 %"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="label-title" for="spendLimitSSP"
            >Spend Limit<span *ngIf="createSspService.isJSConnection()">
              *</span
            >
            <app-tooltip
              [tooltipTitle]="'Maximum allowed spending on this endpoint'"
            ></app-tooltip>
          </label>
          <div class="ssp-limit">
            <input
              nz-input
              type="number"
              class="form-control"
              id="spendLimitSSP"
              name="spendLimit"
              [required]="createSspService.isJSConnection()"
              formControlName="spendLimit"
            />
          </div>
        </div>
        <div
          class="form-group"
          *ngIf="createSspService.isJSConnection()"
          formGroupName="js"
        >
          <label class="label-title" for="jsBidfloorSSP"
            >Fixed Bidfloor *
            <app-tooltip
              tooltipTitle="The value entered here is used as the fixed payout to SSP partners. This value represents the cost per thousand impressions (CPM). The minimal Fixed Bidfloor value is 0.01."
            ></app-tooltip>
          </label>
          <div class="ssp-limit">
            <input
              nz-input
              type="number"
              class="form-control"
              name="defaultBidfloor"
              id="jsBidfloorSSP"
              min="0"
              max="100"
              required
              formControlName="bidfloor"
              qa="bidfloor"
              min="0"
            />
          </div>
        </div>
        <ng-container *ngIf="createSspService.isJSConnection()">
          <hr />
          <div>Size *</div>
          <div class="form-group">
            <nz-select
              nzShowSearch
              nzPlaceHolder="Select Size"
              formControlName="selectedSize"
              (ngModelChange)="onChangeSize($event)"
              name="size-select"
            >
              <nz-option
                *ngFor="let size of createSspService.listOfSizes"
                [nzValue]="size.id"
                [nzLabel]="size.name"
              ></nz-option>
            </nz-select>
          </div>
          <div class="form-group" formGroupName="js">
            <div class="row b-row dsp-api-link-wrap">
              <div class="col-6">
                <label>Width *</label>
                <input
                  type="number"
                  nz-input
                  name="w"
                  id="customSSPWidthJS"
                  formControlName="w"
                  required
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <label>Height *</label>
                <input
                  type="number"
                  nz-input
                  name="h"
                  id="customSSPHeightJS"
                  formControlName="h"
                  required
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="form-group" formGroupName="js">
            <label for="backfillSSP">Backfill</label>
            <textarea
              nz-input
              class="form-control"
              id="backfillSSP"
              name="backfill"
              formControlName="backfill"
            ></textarea>
          </div>
        </ng-container>
      </div>
      <div class="part">
        <div class="ssp-stat-wrap">
          <div class="form-title">
            Endpoint & API Stats
            <app-tooltip
              [tooltipTitle]="
                'Links for receiving statistics from the endpoint and provide statistic from the platform to the endpoint'
              "
            ></app-tooltip>
          </div>
          <div *ngIf="createSspService.isRtbConnection()" class="col-12">
            <div class="form-group">
              <label>
                Custom Adapter
                <app-tooltip [tooltipTitle]="'API adapters list'"></app-tooltip>
              </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Custom Adapter"
                [(ngModel)]="createSspService.selectedAdapters"
                name="selectedAdapters"
                (ngModelChange)="onChangeCustomAdapters($event)"
                [ngModelOptions]="{ standalone: true }"
              >
                <nz-option
                  nzCustomContent
                  *ngFor="let adapter of createSspService.rtbAdapters"
                  [nzValue]="adapter.id"
                  [nzLabel]="adapter.name"
                  [nzDisabled]="adapter.disabled"
                >
                  <span
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      createSspService.getTooltipForHuaweiAdapter(adapter.name)
                    "
                    nzTooltipPlacement="top"
                    >{{ adapter.name }}
                  </span>
                </nz-option>
              </nz-select>
            </div>
            <div class="block-fields" *ngIf="createSspService.isShowFields">
              <h3 class="prebid-header">Additional Adapters Fields</h3>
              <div
                class="form-group"
                *ngFor="let item of createSspService.adaptersRtb; let i = index"
              >
                <label
                  >{{ item.name }}
                  <span *ngIf="isRequiredAdapterField(item.name)">*</span>
                  <app-tooltip
                    *ngIf="item.tooltip"
                    [tooltipTitle]="item.tooltip"
                  ></app-tooltip>
                </label>
                <input
                  nz-input
                  class="form-control"
                  (input)="onChangeInput($event)"
                  [(ngModel)]="item.field"
                  [ngModelOptions]="{ standalone: true }"
                  [required]="
                    createSspService.adaptersItem.config.paramsReq[item.name]
                      .required
                  "
                />
              </div>
            </div>
          </div>
          <hr class="stat-hr" *ngIf="createSspService.isRtbConnection()" />
          <div class="form-group" *ngIf="createSspService.isVastConnection()">
            <app-vast-endpoint
              [connection]="createSspService.vast"
              [partnerNs]="createSspService.partnerSettings.ns"
              [sizeRequired]="createSspService.isSizeRequired"
              [connectionType]="createSspService.connectionType"
              [adServer]="createSspService.selectedServer"
              [adServerMacroses]="createSspService.adServerMacroses"
              [adtype]="createSspService.adTypeControlValue"
              [seat]="createSspService.seat"
              [token]="createSspService.token"
              [protocol]="createSspService.protocol"
              [name]="createSspService.formValue.name"
              [selectedMacrosList]="createSspService.vast.macrosList"
              [listOfMacros]="createSspService.listOfMacros"
              [macrosListVast]="createSspService.macrosListVast"
              (changeVastEndpoint)="onChangeVastEndpoint($event)"
              (changeVastMacrosList)="onChangeVastMacrosList($event)"
            ></app-vast-endpoint>
          </div>

          <hr class="stat-hr" *ngIf="!createSspService.isRtbConnection()" />
          <div class="row b-row" *ngIf="createSspService.isJSConnection()">
            <app-generated-js-tag
              [tagType]="createSspService.jsTagType"
              [jsTag]="createSspService.endpointUrl"
              [macrosListJs]="createSspService.macrosListJs"
              [selectedMacros]="createSspService.selectedJsMacros"
              (changedJsTag)="onChangeMacros($event)"
              (changedJsTagType)="onTagTypeChange($event)"
              qa="jsTagTypeDropdown"
            ></app-generated-js-tag>
          </div>
          <hr *ngIf="createSspService.isJSConnection()" />
          <div class="form-group" *ngIf="createSspService.isShowImpTriggering">
            <label>Impression triggering</label>
            <nz-select
              nzPlaceHolder="Select Impression triggering"
              formControlName="imp_triggering"
              name="imp_triggering"
            >
              <nz-option
                *ngFor="
                  let impTriggeringItem of createSspService.impTriggeringItems
                "
                [nzValue]="impTriggeringItem.id"
                [nzLabel]="impTriggeringItem.name"
              ></nz-option>
            </nz-select>
          </div>
          <div class="form-group">
            <div class="row b-row">
              <div class="col-9">
                <label for="sspApiUrl">SSP's Statistics API link</label>
                <input
                  type="default"
                  nz-input
                  class="form-control"
                  name="sspApiUrl"
                  id="sspApiUrl"
                  formControlName="apiLink"
                  (change)="
                    onValidateLink(
                      createSspService.formValue['apiLink'],
                      $event
                    )
                  "
                />
                <app-check-endpoint-status
                  [apilink]="createSspService.apiLink"
                  [side]="'ssp'"
                  [endpointValidationStatuses]="
                    createSspService.apiLinkValidationStatus
                  "
                  [endpointId]="createSspService.formValue.id"
                  (hasError)="getError($event)"
                >
                </app-check-endpoint-status>
                <small>replace date with a placeholder [%Y-m-d%]</small>
              </div>
              <div class="col-3">
                <button
                  buttonLabel="testSspApiLink"
                  nz-button
                  nzType="default"
                  class="test-link-button"
                  (click)="
                    onApiLinkTest(createSspService.formValue.apiLink, $event)
                  "
                  [disabled]="createSspService.isDisabledTest"
                >
                  Test
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="createSspService.isVastConnection()">
            <div class="form-title">Filters</div>
            <div class="form-group">
              <div class="checkbox">
                <label
                  checkboxLabel="hasResponseAdomainSSP"
                  nz-checkbox
                  formControlName="has_response_adomain"
                  (ngModelChange)="
                    onChangeChecked($event, 'has_response_adomain')
                  "
                  name="has_response_adomain"
                >
                  Responses with adomain
                </label>
              </div>
              <div class="check-tooltip">
                <label
                  checkboxLabel="useSecureFilterSSP"
                  nz-checkbox
                  formControlName="use_secure_filter"
                  name="use_secure_filter"
                >
                  Secure links only
                  <app-tooltip
                    [tooltipTitle]="
                      'if the response from DSP contains at least one insecure link (http format) - such response will be dropped for this EP'
                    "
                  ></app-tooltip>
                </label>
              </div>
              <div class="checkbox">
                <label
                  nz-checkbox
                  formControlName="is_origin_device_object"
                  name="is_origin_device_object"
                >
                  Original device object
                  <app-tooltip
                    tooltipTitle="When enabled, the original “device type” value from the request will be passed to the DSP.
                  If it's missing, the system will attempt to detect the device type using the User-Agent.
                  If both are unavailable, the request will be dropped."
                  ></app-tooltip>
                </label>
              </div>
              <div class="check-tooltip">
                <label
                  nz-checkbox
                  formControlName="is_default_coppa"
                  name="is_default_coppa"
                >
                  Default COPPA
                  <app-tooltip
                    tooltipTitle="When enabled, the system will automatically insert coppa=0 into bid requests if the original request does not include the COPPA attribute. This logic applies only to requests with the USA geo."
                  ></app-tooltip>
                </label>
              </div>
              <div class="checkbox">
                <label
                  checkboxLabel="isOriginDeviceObjectSSP"
                  nz-checkbox
                  formControlName="use_geo_from_ip"
                  name="use_geo_from_ip"
                >
                  Prioritize GEO from IP
                  <app-tooltip
                    tooltipTitle="When enabled, the system will attempt to determine GEO based on the user’s IP address.
                    If unsuccessful, the GEO from the original SSP request will be used. If neither is available, the GEO field will be passed empty to the DSP.
                    Note: This setting affects only the GEO field and operates independently from the “Original Device Object” checkbox.
                    If both checkboxes are enabled, the system will still prioritize IP-based GEO detection."
                  ></app-tooltip>
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="row b-row">
                <div class="col-12">
                  <label class="label-title"
                    >DSPs
                    <app-tooltip
                      [tooltipTitle]="
                        'Choose allowed/blocked DSPs for this endpoint'
                      "
                    ></app-tooltip>
                  </label>
                </div>
                <div class="col-4">
                  <nz-select
                    class="select-dsps"
                    [class.allowed-filter]="
                      createSspService.formValue['allowedDspListTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createSspService.formValue['allowedDspListTrigger'] === 0
                    "
                    formControlName="allowedDspListTrigger"
                    name="allowedDspListTrigger"
                  >
                    <nz-option
                      *ngFor="
                        let trigger of createSspService.allowCountriesTrigger
                      "
                      [nzValue]="trigger.id"
                      [nzLabel]="trigger.name"
                    ></nz-option>
                  </nz-select>
                </div>
                <div class="col-8">
                  <nz-tree-select
                    name="dspList"
                    nzPlaceHolder="Select DSP Endpoint(s)"
                    nzPlacement="bottomRight"
                    [nzDropdownStyle]="{ width: '300px' }"
                    [class.allowed-filter]="
                      createSspService.formValue['allowedDspListTrigger'] === 1
                    "
                    [class.blocked-filter]="
                      createSspService.formValue['allowedDspListTrigger'] === 0
                    "
                    formControlName="dspList"
                    [nzMaxTagCount]="3"
                    [nzMaxTagPlaceholder]="omittedPlaceHolder"
                    [nzNodes]="createSspService.companiesDSPDropdown"
                    [nzAllowClear]="false"
                    [nzShowSearch]="true"
                    [nzMultiple]="true"
                    nzVirtualHeight="250px"
                    nzCheckable
                    [nzTreeTemplate]="customTpl"
                    [nzHideUnMatched]="true"
                  ></nz-tree-select>
                  <ng-template #omittedPlaceHolder let-omittedValues
                    >and {{ omittedValues.length }} more...</ng-template
                  >
                  <ng-template #customTpl let-item>
                    {{ item.title | trunc: [20] }}
                  </ng-template>
                </div>
              </div>
            </div>

            <hr *ngIf="hasScanner" />

            <div *ngIf="hasScanner" class="form-title form-title--scanners">
              Scanners
            </div>
            <div
              class="form-group"
              [class.isPixalatePrebid]="
                createSspService.partnerSettings.usePixalatePrebid
              "
              *ngIf="hasScanner"
            >
              <div class="custom-checkbox">
                <div class="check-tooltip-scanners">
                  <div class="checkbox" *ngIf="isBotmanPostBidIsEnabled()">
                    <label
                      checkboxLabel="botmanPostBidSSP"
                      nz-checkbox
                      formControlName="botman_enable_postbid"
                      (ngModelChange)="
                        onChangeChecked($event, 'enable_postbid')
                      "
                      name="botman_enable_postbid"
                      >Botman (Post-bid)</label
                    >
                  </div>
                </div>
                <div class="check-tooltip-scanners">
                  <div class="checkbox" *ngIf="isBotmanPreBidIsEnabled()">
                    <label
                      checkboxLabel="botmanPreBidSSP"
                      nz-checkbox
                      name="botman_enable_prebid"
                      formControlName="botman_enable_prebid"
                      (ngModelChange)="onChangeChecked($event, 'enable_prebid')"
                      >Botman (Pre-bid)</label
                    >
                  </div>
                </div>

                <div
                  class="check-tooltip-scanners"
                  *ngIf="isFraudLogixEnabled()"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="fraudLogixPostBidDSP"
                      nz-checkbox
                      formControlName="fraud_logix_enable_postbid"
                      name="fraud_logix_enable_postbid"
                    >
                      Fraudlogix (Post-bid)
                    </label>
                  </div>
                </div>

                <div class="check-tooltip-scanners">
                  <div
                    class="checkbox"
                    *ngIf="createSspService.partnerSettings.useGeoedge"
                  >
                    <label
                      checkboxLabel="useGeoedgeSSP"
                      nz-checkbox
                      name="geoedge"
                      formControlName="useGeoedge"
                      (ngModelChange)="onChangeChecked($event, 'useGeoedge')"
                      >Geoedge</label
                    >
                  </div>
                </div>
                <div class="check-tooltip-scanners">
                  <div
                    class="checkbox"
                    *ngIf="createSspService.formValue.useGeoedge"
                  >
                    <input
                      nz-input
                      id="geoedgeKey"
                      class="form-control"
                      name="geoedge_key"
                      type="text"
                      placeholder="Enter the custom key"
                      formControlName="geoedge_key"
                      (ngModelChange)="onChangeChecked($event, 'geoedge_key')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              customLabel="pixalatePrebidBlockSSP"
              class="pixalate-block"
              *ngIf="createSspService.partnerSettings.usePixalatePrebid"
              formGroupName="pixalate_pb_settings"
            >
              <div
                *ngIf="createSspService.partnerSettings.pixalate_pb_settings.ip"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidIpSSP"
                    nz-checkbox
                    formControlName="ip"
                    name="pixalate_pb_settings.ip"
                    >Pixalate Pre-bid IP filter</label
                  >
                </div>
                <div
                  class="input-group"
                  *ngIf="createSspService.formValue.pixalate_pb_settings.ip"
                >
                  <label>Pixalate IP IVT Percent</label>
                  <input
                    nz-input
                    type="number"
                    width="10"
                    id="pixalateIpPercentSSP"
                    name="pixalate_pb_settings.ip_percent"
                    formControlName="ip_percent"
                    (keyup)="onPreventInput($event, 'ip_percent')"
                    (click)="onPreventInput($event, 'ip_percent')"
                    class="form-control"
                  />
                </div>
              </div>
              <div
                *ngIf="
                  createSspService.partnerSettings.pixalate_pb_settings.ifa
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidIFASSP"
                    nz-checkbox
                    formControlName="ifa"
                    name="pixalate_pb_settings.ifa"
                    >Pixalate Pre-bid IFA filter</label
                  >
                </div>
                <div
                  class="input-group"
                  *ngIf="createSspService.formValue.pixalate_pb_settings.ifa"
                >
                  <label>Pixalate IFA IVT Percent</label>
                  <input
                    nz-input
                    type="number"
                    width="10"
                    id="pixalateIFAIVTPercentSSP"
                    name="pixalate_pb_settings.ifa_percent"
                    formControlName="ifa_percent"
                    (keyup)="onPreventInput($event, 'ifa_percent')"
                    (click)="onPreventInput($event, 'ifa_percent')"
                    class="form-control"
                  />
                </div>
              </div>
              <div
                *ngIf="createSspService.partnerSettings.pixalate_pb_settings.ua"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidUASSP"
                    nz-checkbox
                    formControlName="ua"
                    name="pixalate_pb_settings.ua"
                    >Pixalate Pre-bid UA filter</label
                  >
                </div>
              </div>
              <div
                *ngIf="
                  createSspService.partnerSettings.pixalate_pb_settings.ott
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidOTTSSP"
                    nz-checkbox
                    formControlName="ott"
                    name="pixalate_pb_settings.ott"
                    >Pixalate Pre-bid OTT filter</label
                  >
                </div>
                <div
                  class="input-group"
                  *ngIf="createSspService.formValue.pixalate_pb_settings.ott"
                >
                  <label>Pixalate OTT IVT Percent</label>
                  <input
                    nz-input
                    type="number"
                    width="10"
                    id="pixalateOttPercentSSP"
                    name="pixalate_pb_settings.ott_percent"
                    (keyup)="onPreventInput($event, 'ott_percent')"
                    (click)="onPreventInput($event, 'ott_percent')"
                    class="form-control"
                  />
                </div>
              </div>
              <div
                *ngIf="
                  createSspService.partnerSettings.pixalate_pb_settings.def_app
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidDefAppSSP"
                    nz-checkbox
                    formControlName="def_app"
                    name="pixalate_pb_settings.def_app"
                    >Pixalate Pre-bid Defased App filter</label
                  >
                </div>
              </div>
              <div
                *ngIf="
                  createSspService.partnerSettings.pixalate_pb_settings.domain
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidDomainSSP"
                    nz-checkbox
                    formControlName="domain"
                    name="pixalate_pb_settings.domain"
                    >Pixalate Pre-bid Domain filter</label
                  >
                </div>
              </div>
              <div
                *ngIf="
                  createSspService.partnerSettings.pixalate_pb_settings.hr_app
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidBundleSSP"
                    nz-checkbox
                    formControlName="hr_app"
                    name="pixalate_pb_settings.hr_app"
                    >Pixalate Pre-bid Bundle filter</label
                  >
                </div>
                <div
                  class="input-group"
                  *ngIf="createSspService.formValue.pixalate_pb_settings.hr_app"
                >
                  <label>Pixalate Bundle IVT Percent</label>
                  <input
                    nz-input
                    type="number"
                    width="10"
                    id="pixalateBundleIVTPercentSSP"
                    name="pixalate_pb_settings.hr_app_percent"
                    formControlName="hr_app_percent"
                    (keyup)="onPreventInput($event, 'hr_app_percent')"
                    (click)="onPreventInput($event, 'hr_app_percent')"
                    class="form-control"
                  />
                </div>
              </div>
              <div
                *ngIf="
                  createSspService.partnerSettings.pixalate_pb_settings
                    .dc_subnet
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePrebidDcSubnetSSP"
                    nz-checkbox
                    formControlName="dc_subnet"
                    name="pixalate_pb_settings.dc_subnet"
                    >Pixalate Pre-bid Data Center IP filter</label
                  >
                </div>
              </div>
            </div>

            <hr />
            <div class="form-title form-title--additional">
              Additional Settings
            </div>
            <div class="checkbox">
              <label
                checkboxLabel="sendTestResponsesSSP"
                nz-checkbox
                formControlName="isForTest"
                name="isForTest"
              >
                Send test responses
              </label>
            </div>
            <div class="check-tooltip">
              <label
                checkboxLabel="hasMaximisedBidpriceSSP"
                nz-checkbox
                formControlName="has_maximised_bidprice"
                name="has_maximised_bidprice"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipMessage(
                    'Maximised Bidprice'
                  )
                "
                nzTooltipPlacement="top"
              >
                Maximised bid price
              </label>

              <app-tooltip
                [tooltipTitle]="
                  'Maximised Bidprice auction is available for SSP and DSP connections using fixed margins.\n' +
                  'This feature will increase the bidprice sent to the SSP. When calculating payouts, only the DSP’s markup is deducted from the bid price, and the SSP’s markup will be ignored.\n' +
                  'This feature increases your chances of winning the auction on the SSP side. Profits are then calculated solely on the fixed markup set by the DSP.'
                "
              ></app-tooltip>
            </div>

            <div class="check-tooltip">
              <label
                nz-checkbox
                formControlName="has_new_iab_categories"
                name="has_new_iab_categories"
                (ngModelChange)="
                  createSspService.onChangeIABCategoriesCheckboxStateHandler(
                    $event
                  )
                "
                >IAB Categories</label
              >
            </div>

            <div
              class="form-group"
              *ngIf="createSspService.formValue.has_new_iab_categories"
            >
              <div class="checkbox">
                <label>
                  IAB Categories
                  <app-tooltip
                    tooltipTitle="Choose the IAB Categories that represent your supply"
                  ></app-tooltip>
                </label>
                <nz-tree-select
                  name="iab_cat"
                  nzPlaceHolder="Select IAB Categories"
                  formControlName="iab_cat"
                  [nzMaxTagCount]="3"
                  [nzMaxTagPlaceholder]="omittedPlaceHolder"
                  [nzNodes]="createSspService.iabCategories"
                  [nzAllowClear]="false"
                  [nzShowSearch]="true"
                  [nzMultiple]="true"
                  nzVirtualHeight="250px"
                  nzCheckable
                ></nz-tree-select>
                <ng-template #omittedPlaceHolder let-omittedValues
                  >and {{ omittedValues.length }} more...</ng-template
                >
              </div>
            </div>

            <div class="check-tooltip">
              <label
                nz-checkbox
                formControlName="is_flexible_size_matching"
                name="is_flexible_size_matching"
                >Flexible size matching</label
              >
              <app-tooltip
                tooltipTitle="Enables processing of bid responses with creatives that are smaller than or equal to the bid request size dimensions."
              ></app-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="part" *ngIf="!createSspService.isVastConnection()">
        <div class="form-title">Filters</div>
        <div class="form-group form-group_chb form-group_check">
          <div class="custom-checkbox">
            <div
              class="checkbox"
              *ngIf="
                createSspService.isRtbConnection() ||
                createSspService.isPreBidConnection() ||
                createSspService.isPrebidJsConnection()
              "
            >
              <label
                checkboxLabel="bcatFilterSSP"
                nz-checkbox
                formControlName="useBcatFilter"
                (ngModelChange)="onChangeBCATCheckboxState($event)"
                name="useBcatFilter"
                >Bcat filter</label
              >
            </div>
            <div
              class="checkbox"
              *ngIf="
                createSspService.isRtbConnection() ||
                createSspService.isPreBidConnection() ||
                createSspService.isPrebidJsConnection()
              "
            >
              <label
                checkboxLabel="badvFilterSSP"
                nz-checkbox
                formControlName="has_badv_filter"
                (ngModelChange)="onChangeChecked($event, 'has_badv_filter')"
                name="hasBadvFilter"
                >Badv filter</label
              >
            </div>
            <div
              class="check-tooltip"
              *ngIf="
                createSspService.isRtbConnection() ||
                createSspService.isPreBidConnection() ||
                createSspService.isPrebidJsConnection()
              "
            >
              <label
                checkboxLabel="iurlFilterSSP"
                nz-checkbox
                formControlName="is_iurl_filter"
                name="is_iurl_filter"
              >
                Filter out DSP responses without iURL
              </label>
              <app-tooltip
                tooltipTitle="Activating “Filter out DSP responses without iURL” checkbox will initiate checking DSP responses for iURL presence.
                If iURL is not present in the DSP response, it will be dropped"
              ></app-tooltip>
            </div>
            <div class="checkbox">
              <label
                checkboxLabel="hasResponseAdomainSSP"
                nz-checkbox
                formControlName="has_response_adomain"
                (ngModelChange)="
                  onChangeChecked($event, 'has_response_adomain')
                "
                name="has_response_adomain"
              >
                Responses with adomain
              </label>
            </div>
            <div class="check-tooltip">
              <label
                checkboxLabel="useSecureFilterSSP"
                nz-checkbox
                formControlName="use_secure_filter"
                name="use_secure_filter"
              >
                Secure links only
                <app-tooltip
                  [tooltipTitle]="
                    'if the response from DSP contains at least one insecure link (http format) - such response will be dropped for this EP'
                  "
                ></app-tooltip>
              </label>
            </div>
            <div class="checkbox">
              <label
                nz-checkbox
                formControlName="is_origin_device_object"
                name="is_origin_device_object"
              >
                Original device object
                <app-tooltip
                  tooltipTitle="When enabled, the original “device type” value from the request will be passed to the DSP.
                If it's missing, the system will attempt to detect the device type using the User-Agent.
                If both are unavailable, the request will be dropped."
                ></app-tooltip>
              </label>
            </div>
            <div class="check-tooltip">
              <label
                nz-checkbox
                formControlName="is_default_coppa"
                name="is_default_coppa"
              >
                Default COPPA
                <app-tooltip
                  tooltipTitle="When enabled, the system will automatically insert coppa=0 into bid requests if the original request does not include the COPPA attribute.
                  This logic applies only to requests with the USA geo."
                ></app-tooltip>
              </label>
            </div>
            <div class="checkbox">
              <label
                checkboxLabel="isOriginDeviceObjectSSP"
                nz-checkbox
                formControlName="use_geo_from_ip"
                name="use_geo_from_ip"
              >
                Prioritize GEO from IP
                <app-tooltip
                  tooltipTitle="When enabled, the system will attempt to determine GEO based on the user’s IP address.
                  If unsuccessful, the GEO from the original SSP request will be used. If neither is available, the GEO field will be passed empty to the DSP.
                  Note: This setting affects only the GEO field and operates independently from the “Original Device Object” checkbox.
                  If both checkboxes are enabled, the system will still prioritize IP-based GEO detection."
                ></app-tooltip>
              </label>
            </div>
          </div>
        </div>
        <div
          class="form-group"
          *ngIf="
            (createSspService.isRtbConnection() ||
              createSspService.isPreBidConnection() ||
              createSspService.isPrebidJsConnection()) &&
            createSspService.formValue.useBcatFilter
          "
        >
          <div class="checkbox">
            <label>Custom BCAT filter</label>
            <nz-tree-select
              name=" iab_bcat"
              nzPlaceHolder="Select Blocked IAB Categories"
              formControlName="iab_bcat"
              [nzMaxTagCount]="3"
              [nzMaxTagPlaceholder]="omittedPlaceHolder"
              [nzNodes]="createSspService.iabBlockedCategories"
              [nzAllowClear]="false"
              [nzShowSearch]="true"
              [nzMultiple]="true"
              nzVirtualHeight="250px"
              nzCheckable
            ></nz-tree-select>
            <ng-template #omittedPlaceHolder let-omittedValues
              >and {{ omittedValues.length }} more...</ng-template
            >
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="createSspService.isJSConnection()"
          formGroupName="js"
        >
          <div class="form-group">
            <label>IAB Categories</label>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select IAB Categories"
              name="categories"
              formControlName="categories"
              [nzShowArrow]="true"
              nzMode="multiple"
            >
              <nz-option
                *ngFor="let category of createSspService.categories"
                [nzValue]="category.id"
                [nzLabel]="category.name"
              >
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div class="form-group">
          <div class="row b-row">
            <div class="col-12">
              <label class="label-title"
                >DSPs
                <app-tooltip
                  [tooltipTitle]="
                    'Choose allowed/blocked DSPs for this endpoint'
                  "
                ></app-tooltip>
              </label>
            </div>
            <div class="col-4">
              <nz-select
                class="select-dsps"
                [class.allowed-filter]="
                  createSspService.formValue['allowedDspListTrigger'] === 1
                "
                [class.blocked-filter]="
                  createSspService.formValue['allowedDspListTrigger'] === 0
                "
                formControlName="allowedDspListTrigger"
                name="allowedDspListTrigger"
              >
                <nz-option
                  *ngFor="let trigger of createSspService.allowCountriesTrigger"
                  [nzValue]="trigger.id"
                  [nzLabel]="trigger.name"
                ></nz-option>
              </nz-select>
            </div>
            <div class="col-8">
              <nz-tree-select
                name="dspList"
                nzPlaceHolder="Select DSP Endpoint(s)"
                nzPlacement="bottomRight"
                [nzDropdownStyle]="{ width: '300px' }"
                [class.allowed-filter]="
                  createSspService.formValue['allowedDspListTrigger'] === 1
                "
                [class.blocked-filter]="
                  createSspService.formValue['allowedDspListTrigger'] === 0
                "
                formControlName="dspList"
                [nzMaxTagCount]="3"
                [nzMaxTagPlaceholder]="omittedPlaceHolder"
                [nzNodes]="createSspService.companiesDSPDropdown"
                [nzAllowClear]="false"
                [nzShowSearch]="true"
                [nzMultiple]="true"
                nzVirtualHeight="250px"
                nzCheckable
                [nzTreeTemplate]="customTpl"
                [nzHideUnMatched]="true"
              ></nz-tree-select>
              <ng-template #omittedPlaceHolder let-omittedValues
                >and {{ omittedValues.length }} more...</ng-template
              >
              <ng-template #customTpl let-item>
                {{ item.title | trunc: [20] }}
              </ng-template>
            </div>
          </div>
        </div>

        <hr *ngIf="hasScanner" />

        <div *ngIf="hasScanner" class="form-title form-title--scanners">
          Scanners
        </div>
        <div
          class="form-group"
          [class.isPixalatePrebid]="
            createSspService.partnerSettings.usePixalatePrebid
          "
          *ngIf="hasScanner"
        >
          <div class="custom-checkbox">
            <div class="check-tooltip-scanners">
              <div class="checkbox" *ngIf="isBotmanPostBidIsEnabled()">
                <label
                  checkboxLabel="botmanPostBidSSP"
                  nz-checkbox
                  formControlName="botman_enable_postbid"
                  (ngModelChange)="onChangeChecked($event, 'enable_postbid')"
                  name="botman_enable_postbid"
                  >Botman (Post-bid)</label
                >
              </div>
            </div>
            <div class="check-tooltip-scanners">
              <div class="checkbox" *ngIf="isBotmanPreBidIsEnabled()">
                <label
                  checkboxLabel="botmanPreBidSSP"
                  nz-checkbox
                  name="botman_enable_prebid"
                  formControlName="botman_enable_prebid"
                  (ngModelChange)="onChangeChecked($event, 'enable_prebid')"
                  >Botman (Pre-bid)</label
                >
              </div>
            </div>
            <div class="check-tooltip-scanners" *ngIf="isMediaGuardEnabled()">
              <div class="checkbox">
                <label
                  checkboxLabel="humanMediaGuardPreBidSSP"
                  nz-checkbox
                  formControlName="media_guard_enable_prebid"
                  name="media_guard_enable_prebid"
                  media_guard_percent
                  >Human MediaGuard (Pre-bid)</label
                >
              </div>
            </div>
            <div
              class="input-group"
              *ngIf="createSspService.formValue.media_guard_enable_prebid"
            >
              <label>Human MediaGuard Scan Ratio</label>
              <input
                nz-input
                type="number"
                width="10"
                id="pixalateIFAIVTPercentSSP"
                name="media_guard_percent"
                formControlName="media_guard_percent"
                class="form-control"
                min="1"
                max="100"
              />
            </div>
            <div class="check-tooltip-scanners" *ngIf="isFraudSensorEnabled()">
              <div class="checkbox">
                <label
                  checkboxLabel="humanFraudsensorPostBidSSP"
                  nz-checkbox
                  formControlName="fraud_sensor_enable_postbid"
                  name="fraud_sensor_enable_postbid"
                  >Human FraudSensor (Post-bid)</label
                >
              </div>
            </div>

            <div class="check-tooltip-scanners" *ngIf="isFraudLogixEnabled()">
              <div class="checkbox">
                <label
                  checkboxLabel="fraudLogixPostBidDSP"
                  nz-checkbox
                  formControlName="fraud_logix_enable_postbid"
                  name="fraud_logix_enable_postbid"
                >
                  Fraudlogix (Post-bid)
                </label>
              </div>
            </div>

            <div
              class="check-tooltip-scanners"
              *ngIf="
                createSspService.isRtbConnection() ||
                createSspService.isPreBidConnection()
              "
            >
              <div
                class="checkbox"
                *ngIf="createSspService.partnerSettings.useTMT"
              >
                <label
                  checkboxLabel="useTMTSSP"
                  nz-checkbox
                  formControlName="useTMT"
                  (ngModelChange)="onChangeChecked($event, 'useTMT')"
                  name="tmt"
                  >TMT</label
                >
              </div>
            </div>
            <div
              class="check-tooltip-scanners"
              *ngIf="
                createSspService.isRtbConnection() ||
                createSspService.isPreBidConnection()
              "
            >
              <div
                class="checkbox"
                *ngIf="createSspService.partnerSettings.usePM"
              >
                <label
                  checkboxLabel="usePMKeySSP"
                  nz-checkbox
                  formControlName="usePMKey"
                  (ngModelChange)="onChangeChecked($event, 'usePMKey')"
                  name="p-media"
                  >Protected Media (Post-bid)</label
                >
              </div>
            </div>
            <div
              class="check-tooltip-scanners"
              *ngIf="
                createSspService.isRtbConnection() ||
                createSspService.isPreBidConnection()
              "
            >
              <div
                class="checkbox"
                *ngIf="createSspService.partnerSettings.usePixalate"
              >
                <label
                  checkboxLabel="usePixalateSSP"
                  nz-checkbox
                  name="is_pixalate_postbid"
                  formControlName="is_pixalate_postbid"
                  (ngModelChange)="
                    onChangeChecked($event, 'is_pixalate_postbid')
                  "
                  >Pixalate (Post-bid)</label
                >
              </div>
            </div>

            <div class="check-tooltip-scanners">
              <div
                class="checkbox"
                *ngIf="createSspService.partnerSettings.useGeoedge"
              >
                <label
                  checkboxLabel="useGeoedgeSSP"
                  nz-checkbox
                  name="geoedge"
                  formControlName="useGeoedge"
                  (ngModelChange)="onChangeChecked($event, 'useGeoedge')"
                  >Geoedge</label
                >
              </div>
            </div>
            <div class="check-tooltip-scanners">
              <div
                class="checkbox"
                *ngIf="createSspService.formValue.useGeoedge"
              >
                <input
                  nz-input
                  id="geoedgeKey"
                  class="form-control"
                  name="geoedge_key"
                  type="text"
                  placeholder="Enter the custom key"
                  formControlName="geoedge_key"
                  (ngModelChange)="onChangeChecked($event, 'geoedge_key')"
                />
              </div>
            </div>
          </div>
          <div
            class="check-tooltip-scanners"
            *ngIf="
              createSspService.isRtbConnection() ||
              createSspService.isPreBidConnection()
            "
          >
            <div
              class="checkbox"
              *ngIf="
                createSspService.partnerSettings.usePMPreBid &&
                !createSspService.isVastConnection()
              "
            >
              <div>
                <div class="check-tooltip">
                  <label
                    checkboxLabel="usePMPrebidSSP"
                    nz-checkbox
                    formControlName="usePMPrebid"
                    name="usePMPrebid"
                    >Protected Media (Pre-bid)</label
                  >
                  <app-tooltip
                    [tooltipTitle]="
                      'Use Protected Media Pre-bid for scanning. If you don\'t want to use it for this endpoint, select the quality of traffic on this endpoint'
                    "
                  ></app-tooltip>
                </div>
                <div
                  class="clearfix"
                  *ngIf="!createSspService.formValue.usePMPrebid"
                ></div>
                <div
                  class="select-tooltip"
                  *ngIf="!createSspService.formValue.usePMPrebid"
                >
                  <label class="label-title"
                    >PM Fraud
                    <app-tooltip
                      [tooltipTitle]="
                        'Clean traffic - we will consider traffic from this endpoint as high-quality and send it to all DSPs\n' +
                        'Fraud traffic - we will consider traffic from this endpoint as low-quality and send it just to DSPs with valid fraud of 100%'
                      "
                    ></app-tooltip>
                  </label>
                  <nz-select
                    nzShowSearch
                    nzPlaceHolder="Select PM Fraud"
                    formControlName="pmIsFraud"
                    name="pmIsFraud"
                  >
                    <nz-option
                      *ngFor="let item of createSspService.fraudItems"
                      [nzValue]="item.id"
                      [nzLabel]="item.name"
                    ></nz-option>
                  </nz-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          customLabel="pixalatePrebidBlockSSP"
          class="pixalate-block"
          *ngIf="createSspService.partnerSettings.usePixalatePrebid"
          formGroupName="pixalate_pb_settings"
        >
          <div *ngIf="createSspService.partnerSettings.pixalate_pb_settings.ip">
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidIpSSP"
                nz-checkbox
                formControlName="ip"
                name="pixalate_pb_settings.ip"
                >Pixalate Pre-bid IP filter</label
              >
            </div>
            <div
              class="input-group"
              *ngIf="createSspService.formValue.pixalate_pb_settings.ip"
            >
              <label>Pixalate IP IVT Percent</label>
              <input
                nz-input
                type="number"
                width="10"
                id="pixalateIpPercentSSP"
                name="pixalate_pb_settings.ip_percent"
                formControlName="ip_percent"
                (keyup)="onPreventInput($event, 'ip_percent')"
                (click)="onPreventInput($event, 'ip_percent')"
                class="form-control"
              />
            </div>
          </div>
          <div
            *ngIf="createSspService.partnerSettings.pixalate_pb_settings.ifa"
          >
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidIFASSP"
                nz-checkbox
                formControlName="ifa"
                name="pixalate_pb_settings.ifa"
                >Pixalate Pre-bid IFA filter</label
              >
            </div>
            <div
              class="input-group"
              *ngIf="createSspService.formValue.pixalate_pb_settings.ifa"
            >
              <label>Pixalate IFA IVT Percent</label>
              <input
                nz-input
                type="number"
                width="10"
                id="pixalateIFAIVTPercentSSP"
                name="pixalate_pb_settings.ifa_percent"
                formControlName="ifa_percent"
                (keyup)="onPreventInput($event, 'ifa_percent')"
                (click)="onPreventInput($event, 'ifa_percent')"
                class="form-control"
              />
            </div>
          </div>
          <div *ngIf="createSspService.partnerSettings.pixalate_pb_settings.ua">
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidUASSP"
                nz-checkbox
                formControlName="ua"
                name="pixalate_pb_settings.ua"
                >Pixalate Pre-bid UA filter</label
              >
            </div>
          </div>
          <div
            *ngIf="createSspService.partnerSettings.pixalate_pb_settings.ott"
          >
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidOTTSSP"
                nz-checkbox
                formControlName="ott"
                name="pixalate_pb_settings.ott"
                >Pixalate Pre-bid OTT filter</label
              >
            </div>
            <div
              class="input-group"
              *ngIf="createSspService.formValue.pixalate_pb_settings.ott"
            >
              <label>Pixalate OTT IVT Percent</label>
              <input
                nz-input
                type="number"
                width="10"
                id="pixalateOttPercentSSP"
                name="pixalate_pb_settings.ott_percent"
                (keyup)="onPreventInput($event, 'ott_percent')"
                (click)="onPreventInput($event, 'ott_percent')"
                class="form-control"
              />
            </div>
          </div>
          <div
            *ngIf="
              createSspService.partnerSettings.pixalate_pb_settings.def_app
            "
          >
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidDefAppSSP"
                nz-checkbox
                formControlName="def_app"
                name="pixalate_pb_settings.def_app"
                >Pixalate Pre-bid Defased App filter</label
              >
            </div>
          </div>
          <div
            *ngIf="createSspService.partnerSettings.pixalate_pb_settings.domain"
          >
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidDomainSSP"
                nz-checkbox
                formControlName="domain"
                name="pixalate_pb_settings.domain"
                >Pixalate Pre-bid Domain filter</label
              >
            </div>
          </div>
          <div
            *ngIf="createSspService.partnerSettings.pixalate_pb_settings.hr_app"
          >
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidBundleSSP"
                nz-checkbox
                formControlName="hr_app"
                name="pixalate_pb_settings.hr_app"
                >Pixalate Pre-bid Bundle filter</label
              >
            </div>
            <div
              class="input-group"
              *ngIf="createSspService.formValue.pixalate_pb_settings.hr_app"
            >
              <label>Pixalate Bundle IVT Percent</label>
              <input
                nz-input
                type="number"
                width="10"
                id="pixalateBundleIVTPercentSSP"
                name="pixalate_pb_settings.hr_app_percent"
                formControlName="hr_app_percent"
                (keyup)="onPreventInput($event, 'hr_app_percent')"
                (click)="onPreventInput($event, 'hr_app_percent')"
                class="form-control"
              />
            </div>
          </div>
          <div
            *ngIf="
              createSspService.partnerSettings.pixalate_pb_settings.dc_subnet
            "
          >
            <div class="checkbox">
              <label
                checkboxLabel="pixalatePrebidDcSubnetSSP"
                nz-checkbox
                formControlName="dc_subnet"
                name="pixalate_pb_settings.dc_subnet"
                >Pixalate Pre-bid Data Center IP filter</label
              >
            </div>
          </div>
        </div>

        <hr />
        <div class="form-title form-title--additional">Additional Settings</div>
        <div
          class="checkbox"
          *ngIf="
            createSspService.isRtbConnection() ||
            createSspService.isPreBidConnection()
          "
        >
          <label
            checkboxLabel="gzipResponsesSSP"
            nz-checkbox
            formControlName="gzipResponses"
            name="gzipResponses"
            >Send gzip responses</label
          >
        </div>
        <div class="checkbox">
          <label
            checkboxLabel="sendTestResponsesSSP"
            nz-checkbox
            formControlName="isForTest"
            name="isForTest"
          >
            Send test responses
          </label>
        </div>
        <div
          class="check-tooltip"
          *ngIf="
            createSspService.isRtbConnection() ||
            createSspService.isPreBidConnection()
          "
        >
          <label
            checkboxLabel="gppSupportSSP"
            nz-checkbox
            formControlName="is_gpp_support"
            name="is_gpp_support"
            >GPP support</label
          >
          <app-tooltip
            [tooltipTitle]="
              'Activating the GPP support checkbox ensures that regulations specified for GPP are verified and applied to all incoming requests at this endpoint'
            "
          ></app-tooltip>
        </div>
        <div class="checkbox" *ngIf="createSspService.isShowDemandBooster">
          <label
            checkboxLabel="hasDemandBoosterSSP"
            nz-checkbox
            formControlName="has_demand_booster"
            name="has_demand_booster"
            nz-tooltip
            nzTooltipOverlayClassName="item-tooltip"
            [nzTooltipTitle]="
              createSspService.restrictionTooltipMessage('Demand Booster')
            "
            nzTooltipPlacement="top"
          >
            Demand Booster
          </label>
        </div>
        <div class="check-tooltip">
          <label
            checkboxLabel="hasMaximisedBidpriceSSP"
            nz-checkbox
            formControlName="has_maximised_bidprice"
            name="has_maximised_bidprice"
            nz-tooltip
            nzTooltipOverlayClassName="item-tooltip"
            [nzTooltipTitle]="
              createSspService.restrictionTooltipMessage('Maximised Bidprice')
            "
            nzTooltipPlacement="top"
          >
            Maximised bid price
          </label>

          <app-tooltip
            tooltipTitle="Maximised Bidprice auction is available for SSP and DSP connections using fixed margins.
              This feature will increase the bidprice sent to the SSP.
              When calculating payouts, only the DSP’s markup is deducted from the bid price, and the SSP’s markup will be ignored.
              This feature increases your chances of winning the auction on the SSP side.
              Profits are then calculated solely on the fixed markup set by the DSP."
          ></app-tooltip>
        </div>
        <div
          class="check-tooltip"
          *ngIf="createSspService.isPrebidJsConnection()"
        >
          <label
            checkboxLabel="hasGppSupportSSP"
            nz-checkbox
            formControlName="is_gpp_support"
            name="is_gpp_support"
            >GPP support</label
          >
          <app-tooltip
            [tooltipTitle]="
              'Activating the GPP support checkbox ensures that regulations specified for GPP are verified and applied to all incoming requests at this endpoint'
            "
          ></app-tooltip>
        </div>
        <div
          class="pub-group"
          *ngIf="
            createSspService.isRtbConnection() ||
            createSspService.isPreBidConnection()
          "
        >
          <label class="label-title">
            Writing publisher IDs
            <app-tooltip
              tooltipTitle="This setting will help you manage writing publisher IDs per requests and responses in the statistics.
            If the supply partner will send you auto-generated publisher IDs, which may be unique per each request, this will lead to issues with statistics load.
            The automated option is selected by default.
            Logic: If daily statistics per particular SSP connection reach 100 000 values of unique publisher id's
            the platform will automatically stop recording requests and response statistics per publisher ids.
            You may enable/disable writing publisher IDs per particular SSP connection inside the statistics at your sole discretion."
            ></app-tooltip>
          </label>
          <nz-select
            nzShowSearch
            nzPlaceHolder="Select Writing Publisher IDs"
            formControlName="writing_pub_ids"
            name="writing_pub_ids"
          >
            <nz-option
              *ngFor="let item of createSspService.pubWritingItems"
              [nzValue]="item.id"
              [nzLabel]="item.name"
            ></nz-option>
          </nz-select>
        </div>

        <div class="check-tooltip">
          <label
            nz-checkbox
            formControlName="has_new_iab_categories"
            name="has_new_iab_categories"
            (ngModelChange)="
              createSspService.onChangeIABCategoriesCheckboxStateHandler($event)
            "
            >IAB Categories</label
          >
        </div>

        <div
          class="form-group"
          *ngIf="createSspService.formValue.has_new_iab_categories"
        >
          <div class="checkbox">
            <label>
              IAB Categories
              <app-tooltip
                tooltipTitle="Choose the IAB Categories that represent your supply"
              ></app-tooltip>
            </label>
            <nz-tree-select
              name="iab_cat"
              nzPlaceHolder="Select IAB Categories"
              formControlName="iab_cat"
              [nzMaxTagCount]="3"
              [nzMaxTagPlaceholder]="omittedPlaceHolder"
              [nzNodes]="createSspService.iabCategories"
              [nzAllowClear]="false"
              [nzShowSearch]="true"
              [nzMultiple]="true"
              nzVirtualHeight="250px"
              nzCheckable
            ></nz-tree-select>
            <ng-template #omittedPlaceHolder let-omittedValues
              >and {{ omittedValues.length }} more...</ng-template
            >
          </div>
        </div>

        <div class="check-tooltip">
          <label
            nz-checkbox
            formControlName="is_flexible_size_matching"
            name="is_flexible_size_matching"
            >Flexible size matching</label
          >
          <app-tooltip
            tooltipTitle="Enables processing of bid responses with creatives that are smaller than or equal to the bid request size dimensions."
          ></app-tooltip>
        </div>

        <div class="check-tooltip">
          <label
            nz-checkbox
            formControlName="is_multi_ad_response"
            name="is_multi_ad_response"
            >Multi-bid response logic</label
          >
          <app-tooltip
            tooltipTitle="When enabled, Multi-bid response logic will activate on the SSP endpoint, allowing multiple creatives/bids to be returned in a single SSP response instead of only one winning creative."
          ></app-tooltip>
        </div>

        <div
          class="form-group"
          *ngIf="createSspService.formValue.is_multi_ad_response"
        >
          <label for="endpointSSPMultiAdResponses"
            >Maximum Bids per response
            <app-tooltip
              tooltipTitle="Defines the maximum number of bids allowed in a single response. Allowed values: from 2 to 10"
            ></app-tooltip>
          </label>
          <input
            nz-input
            type="number"
            id="endpointSSPMultiAdResponses"
            name="multi_ad_responses"
            formControlName="multi_ad_responses"
            class="form-control"
            min="2"
            max="10"
          />
        </div>
      </div>

      <div class="part" *ngIf="createSspService.isVastConnection()">
        <div formGroupName="vast">
          <div class="form-title">VAST Extensions</div>

          <!-- Rewarded -->
          <div class="form-group vast-ext-row vast-ext-row--switch">
            <div class="vast-ext-row__label">
              <span>Rewarded</span>
              <app-tooltip
                tooltipTitle="Activates rewarded video handling and fallback signalling."
              ></app-tooltip>
            </div>
            <div class="vast-ext-row__control">
              <nz-switch
                formControlName="is_rewarded"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              ></nz-switch>
            </div>
          </div>

          <!-- VAST extensions fields -->
          <div>
            <div class="form-group">
              <label>
                Skip
                <app-tooltip
                  tooltipTitle="Allows users to skip the video ad"
                ></app-tooltip>
              </label>
              <nz-select
                nzPlaceHolder="Select Skip"
                formControlName="skip"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.skipItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>

            <div
              class="form-group form-group_inline"
              *ngIf="createSspService.isShowSkipFields()"
            >
              <div class="row">
                <div class="col-6">
                  <label>
                    Skip Min
                    <app-tooltip
                      tooltipTitle="Minimum video length (sec) for it to be skipped"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    type="number"
                    class="form-control"
                    formControlName="skipmin"
                  />
                </div>
                <div class="col-6">
                  <label>
                    Skip After
                    <app-tooltip
                      tooltipTitle="Seconds until the skip button appears"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    type="number"
                    class="form-control"
                    formControlName="skipafter"
                  />
                </div>
              </div>
            </div>

            <div class="form-group form-group_inline">
              <div class="row">
                <div class="col-6">
                  <label>
                    Min Duration
                    <app-tooltip
                      tooltipTitle="Minimum allowed video ad length in seconds"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    type="number"
                    class="form-control"
                    formControlName="minduration"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      createSspService.restrictionTooltipForVastExtensions()
                    "
                    nzTooltipPlacement="top"
                  />
                </div>
                <div class="col-6">
                  <label>
                    Max Duration
                    <app-tooltip
                      tooltipTitle="Maximum allowed video ad length in seconds"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    type="number"
                    class="form-control"
                    formControlName="maxduration"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      createSspService.restrictionTooltipForVastExtensions()
                    "
                    nzTooltipPlacement="top"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>
                Start Delay
                <app-tooltip
                  tooltipTitle="Ad placement timing in the video content"
                ></app-tooltip>
              </label>
              <nz-select
                nzPlaceHolder="Select Start Delay"
                formControlName="startdelay"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.startDelayItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>

            <div
              class="form-group"
              *ngIf="createSspService.isShowStartDelayMidControls()"
            >
              <label for="startdelay">Mid-roll Delay</label>
              <input
                nz-input
                type="number"
                class="form-control"
                formControlName="startdelaymid"
              />
            </div>

            <div class="form-group">
              <label>
                Placement
                <app-tooltip
                  tooltipTitle="Video ad placement type (OpenRTB 2.5)"
                ></app-tooltip>
              </label>
              <nz-select
                nzPlaceHolder="Select Placement"
                formControlName="placement"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.placementItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>

            <div class="form-group">
              <label>
                Plcmt
                <app-tooltip
                  tooltipTitle="Video ad placement type (OpenRTB 2.6)"
                ></app-tooltip>
              </label>
              <nz-select
                nzPlaceHolder="Select Plcmt"
                formControlName="plcmt"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.plcmtItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>

            <div class="form-group">
              <label>
                Mimes
                <app-tooltip
                  tooltipTitle="Supported media file formats"
                ></app-tooltip>
              </label>
              <nz-select
                nzMode="tags"
                nzPlaceHolder="Select Mimes"
                formControlName="mimes"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.mimesItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>

            <div class="form-group">
              <label>
                Position
                <app-tooltip
                  tooltipTitle="Ad position on the page layout"
                ></app-tooltip>
              </label>
              <nz-select
                nzPlaceHolder="Select Position"
                formControlName="pos"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  nzCustomContent
                  *ngFor="let item of createSspService.positionItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                >
                  <span
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="item.desc"
                    nzTooltipPlacement="top"
                    >{{ item.name }}
                  </span>
                </nz-option>
              </nz-select>
            </div>

            <div class="form-group">
              <label>
                Playback methods
                <app-tooltip
                  tooltipTitle="Video autoplay and sound behavior"
                ></app-tooltip>
              </label>
              <nz-select
                nzMode="multiple"
                nzPlaceHolder="Select Playback methods"
                formControlName="playbackmethod"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.playbackmethodItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>

            <div class="form-group">
              <label>
                Protocols
                <app-tooltip
                  tooltipTitle="Supported ad response protocols and versions"
                ></app-tooltip>
              </label>
              <nz-select
                nzMode="multiple"
                nzPlaceHolder="Select Protocols"
                formControlName="protocols"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.protocolsItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>

            <div class="form-group">
              <label>
                API Frameworks
                <app-tooltip
                  tooltipTitle="Supported ad API frameworks"
                ></app-tooltip>
              </label>
              <nz-select
                nzMode="multiple"
                nzPlaceHolder="Select API Frameworks"
                formControlName="api"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  createSspService.restrictionTooltipForVastExtensions()
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let item of createSspService.apiProtocolsItems"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *nzModalFooter>
      <button
        nz-button
        class="btn-submit"
        type="submit"
        nzType="primary"
        [disabled]="createSspService.isDisableSubmit"
        (click)="onSubmit()"
        qa="generateEndpoint"
      >
        Generate Endpoint
      </button>
      <button
        nz-button
        nzType="default"
        class="btn-cancel"
        (click)="onCancel()"
        type="button"
      >
        Cancel
      </button>
    </div>
  </div>
</form>
